module.exports = __webpack_public_path__ + "img/taptap-code.6c2e2169.png";